// src/reducers/portfolioReducer.js
const initialState = {
    orders: [],
    currentPositions: [],
    squaredOffPositions: [],
    fetchData: [],
    error: null,
    exchangeTokens: {},
    activeTab: 'current',
    clientPositions: [],
    loading: false,
    hasLoadedOnce: false, // ✅ NEW


};

export default function portfolioReducer(state = initialState, action) {
    switch (action.type) {
        case 'SET_ACTIVE_TAB':
            return {
                ...state,
                activeTab: action.payload,
                orders: action.payload === 'square_off' ? state.squaredOffPositions : state.currentPositions
            };
        // ✅ START LOADING
        case 'CLIENT_POSITIONS_GET':
            return {
                ...state,
                loading: true,
            };

        case 'CLIENT_POSITIONS_GET_SUCCESS':
            return {
                ...state,
                clientPositions: action.payload,
                loading: false,
                hasLoadedOnce: true,
                error: null,
            };

        case 'FETCH_CURRENT_POSITIONS_SUCCESS':
            return {
                ...state,
                currentPositions: action.payload.orders,
                orders: state.activeTab === 'current' ? action.payload.orders : state.orders,
                exchangeTokens: action.payload.exchangeTokens,
                error: null,
            };

        case 'FETCH_SQUARED_OFF_POSITIONS_SUCCESS':
            return {
                ...state,
                squaredOffPositions: action.payload.orders,
                orders: state.activeTab === 'square_off' ? action.payload.orders : state.orders,
                error: null,
            };

        case 'FETCH_MARKET_DATA_SUCCESS':
            return {
                ...state,
                fetchData: action.payload,
                error: null,
            };

        case 'FETCH_PORTFOLIO_FAILURE':
        case 'FETCH_MARKET_DATA_FAILURE':
        case 'CLOSE_ALL_ORDERS_FAILURE':
            return {
                ...state,
                loading: false,
                hasLoadedOnce: true,
                error: action.payload,
            };

        case 'CLOSE_ALL_ORDERS_SUCCESS':
            return state;

        default:
            return state;
    }
}